module.exports = __webpack_public_path__ + "8f4643e1007562f0d74156316f5ad7e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/caratScale/0.75ct.png
// module id = 798
// module chunks = 0